import { apiRequest } from './apiClient';

export const getTrips = async () => {
  return apiRequest('/trips');
};

export const getTrip = async (id) => {
  return apiRequest(`/trips/${id}`);
};

export const createTrip = async (tripData) => {
  const formattedData = {
    ...tripData,
    price: Number(tripData.price),
    dates: tripData.dates || '',
    image_url: tripData.image_url || null,
  };
  return apiRequest('/trips', { method: 'POST', body: formattedData, modelLabel: 'paquete' });
};

export const updateTrip = async (id, tripData) => {
  const formattedData = {
    ...tripData,
    price: Number(tripData.price),
    dates: tripData.dates || '',
    image_url: tripData.image_url || null,
  };
  return apiRequest(`/trips/${id}`, { method: 'PUT', body: formattedData, modelLabel: 'paquete' });
};

export const deleteTrip = async (id) => {
  return apiRequest(`/trips/${id}`, { method: 'DELETE', modelLabel: 'paquete' });
};

export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('image', file);

  return apiRequest('/upload', {
    method: 'POST',
    body: formData,
    successMessage: 'Imagen subida correctamente.',
  });
};